import { createReducer, ActionType } from "typesafe-actions";
import * as actions from "./actions";
import initialState from "./state";
import { OtherScoresState } from "./types";

type Action = ActionType<typeof actions>;

const reducer = createReducer<OtherScoresState, Action>(initialState)
  .handleAction(actions.addStudentId, (state, { payload }) => ({
    ...state,
    arrayIds: [...state.arrayIds, payload],
  }))
  .handleAction(actions.addReport, (state, { payload }) => ({
    ...state,
    arrayIds: state.arrayIds.filter((id) => id !== payload.studentId),
    reports: {
      ...state.reports,
      [payload.studentId]: payload,
    },
  }))
  .handleAction(actions.setIntervalId, (state, { payload }) => ({
    ...state,
    intervalId: payload,
  }));

export default reducer;
